function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import foundations from "../components/ConstructKit/foundations";
var v3Colors = {
  reaRed: "#e4002b",
  reaRed90: "#b00020",
  bluestone: "#333f48",
  bluestone90: "#42505a",
  white: "#ffffff",
  orange: "#ed8b00",
  yellow: "#ffb200",
  yellow105: "#f7ae01",
  teal: "#00beb3",
  teal105: "#22b7ae",
  blue: "#0084ff",
  purple: "#93227e",
  shadowstone: "#21282e",
  pebble: "#697684",
  pebble60: "#a5adb5",
  pebble30: "#d2d5da",
  pebble15: "#e9ebed",
  pebble05: "#f7f8f9",
  ocean: "#2b6ed2",
  ocean05: "#f4f7fc",
  ocean30: "#bfd3f1",
  ocean15: "#dfe9f8",
  ocean60: "#80a8e4",
  ocean95: "#57a0ff",
  emerald: "#008744",
  emerald95: "#009e4f",
  burntOrange: "#d43900",
  burntOrange95: "#ff7c4d",
  obsidian: "#11161a",
  obsidian30: "#2e353e",
  obsidian65: "#22282f",
  obsidian95: "#1c2228"
};
var v3Fonts = {
  bold: {
    fontFamily: '"Museo-Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
    fontWeight: 700
  },
  medium: {
    fontFamily: '"Museo-Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
    fontWeight: 500
  },
  regular: {
    fontFamily: '"Museo-Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
    fontWeight: 300
  }
};

//prettier-ignore
var palette = _extends({}, foundations.palette, {
  textPrimary: {
    light: v3Colors.bluestone,
    dark: v3Colors.pebble15
  },
  textSecondary: {
    light: v3Colors.pebble,
    dark: v3Colors.pebble60
  },
  textInvertedStatic: {
    light: v3Colors.white,
    dark: v3Colors.pebble15
  },
  textInverted: {
    light: v3Colors.white,
    dark: v3Colors.bluestone
  },
  textDisabled: {
    light: v3Colors.pebble60,
    dark: v3Colors.pebble
  },
  textInformation: {
    light: v3Colors.ocean,
    dark: v3Colors.ocean95
  },
  textSuccess: {
    light: v3Colors.emerald,
    dark: v3Colors.emerald95
  },
  textWarning: {
    light: v3Colors.burntOrange,
    dark: v3Colors.burntOrange95
  },
  backgroundBrandStatic: {
    light: v3Colors.reaRed,
    dark: v3Colors.reaRed
  },
  backgroundPrimary: {
    light: v3Colors.white,
    dark: v3Colors.obsidian95
  },
  backgroundPrimaryBase: {
    light: v3Colors.white,
    dark: v3Colors.obsidian95
  },
  backgroundPrimaryLow: {
    light: v3Colors.white,
    dark: v3Colors.bluestone
  },
  backgroundPrimaryHigh: {
    light: v3Colors.white,
    dark: v3Colors.shadowstone
  },
  backgroundSecondaryBase: {
    light: v3Colors.pebble05,
    dark: v3Colors.obsidian
  },
  backgroundSecondary: {
    light: v3Colors.pebble15,
    dark: v3Colors.bluestone90
  },
  backgroundSecondaryInvertedStatic: {
    light: v3Colors.shadowstone,
    dark: v3Colors.pebble60
  },
  backgroundPrimaryInverted: {
    light: v3Colors.bluestone,
    dark: v3Colors.pebble15
  },
  backgroundPrimaryInvertedStatic: {
    light: v3Colors.bluestone,
    dark: v3Colors.pebble
  },
  backgroundWarning: {
    light: v3Colors.white,
    dark: v3Colors.obsidian95
  },
  backgroundInformation: {
    light: v3Colors.white,
    dark: v3Colors.obsidian95
  },
  backgroundSuccess: {
    light: v3Colors.white,
    dark: v3Colors.obsidian95
  },
  borderBrandStatic: {
    light: v3Colors.reaRed,
    dark: v3Colors.reaRed
  },
  borderPrimary: {
    light: v3Colors.pebble,
    dark: v3Colors.pebble15
  },
  borderSecondary: {
    light: v3Colors.pebble30,
    dark: v3Colors.bluestone
  },
  borderErrored: {
    light: v3Colors.burntOrange,
    dark: v3Colors.burntOrange95
  },
  linkPrimary: {
    light: v3Colors.ocean,
    dark: v3Colors.ocean95
  },
  linkSecondary: {
    light: v3Colors.pebble,
    dark: v3Colors.pebble60
  },
  backgroundHoveredBrandStatic: {
    light: v3Colors.reaRed90,
    dark: v3Colors.reaRed90
  },
  backgroundHoveredPrimary: {
    light: v3Colors.pebble05,
    dark: v3Colors.obsidian65
  },
  backgroundHoveredPrimaryInverted: {
    light: v3Colors.shadowstone,
    dark: v3Colors.pebble30
  },
  backgroundHoveredPrimaryInvertedStatic: {
    light: v3Colors.shadowstone,
    dark: v3Colors.shadowstone
  },
  backgroundHoveredSecondary: {
    light: v3Colors.pebble30,
    dark: v3Colors.pebble
  },
  backgroundFocusedPrimary: {
    light: v3Colors.pebble05,
    dark: v3Colors.shadowstone
  },
  borderFocusedInvertedStatic: {
    light: v3Colors.pebble15,
    dark: v3Colors.pebble15
  },
  borderFocused: {
    light: v3Colors.bluestone,
    dark: v3Colors.pebble30
  },
  backgroundSelected: {
    light: v3Colors.bluestone,
    dark: v3Colors.pebble15
  },
  backgroundDisabled: {
    light: v3Colors.pebble15,
    dark: v3Colors.bluestone
  },
  borderDisabled: {
    light: v3Colors.pebble30,
    dark: v3Colors.pebble
  },
  borderHovered: {
    light: v3Colors.bluestone,
    dark: v3Colors.pebble15
  },
  borderSelected: {
    light: v3Colors.bluestone,
    dark: v3Colors.pebble15
  },
  backgroundOverlayStatic: {
    light: "rgba(33, 40, 46, 0.8)",
    dark: "rgba(33, 40, 46, 0.8)"
  },
  //shadowstone

  graphicOrange: {
    light: v3Colors.orange,
    dark: v3Colors.orange
  },
  graphicYellow: {
    light: v3Colors.yellow,
    dark: v3Colors.yellow105
  },
  graphicTeal: {
    light: v3Colors.teal,
    dark: v3Colors.teal105
  },
  graphicBlue: {
    light: v3Colors.blue,
    dark: v3Colors.blue
  },
  graphicPurple: {
    light: v3Colors.purple,
    dark: v3Colors.purple
  }
});
var typography = {
  display: _extends({
    fontSize: "2.625rem",
    lineHeight: "2.875rem"
  }, v3Fonts.regular),
  largeTitle: _extends({
    fontSize: "2.25rem",
    lineHeight: "2.875rem"
  }, v3Fonts.regular),
  title01: _extends({
    fontSize: "1.5rem",
    lineHeight: "1.75rem"
  }, v3Fonts.bold),
  title02: _extends({
    fontSize: "1.25rem",
    lineHeight: "1.625rem"
  }, v3Fonts.bold),
  title03: _extends({
    fontSize: "1.125rem",
    lineHeight: "1.375rem"
  }, v3Fonts.bold),
  body01: _extends({
    fontSize: "1rem",
    lineHeight: "1.5rem"
  }, v3Fonts.regular),
  body02: _extends({
    fontSize: "0.875rem",
    lineHeight: "1.25rem"
  }, v3Fonts.regular),
  caption: _extends({
    fontSize: "0.75rem",
    lineHeight: "1rem"
  }, v3Fonts.regular),
  overline: _extends({
    fontSize: "0.75rem",
    lineHeight: "1rem",
    textTransform: "uppercase",
    letterSpacing: "0.075rem"
  }, v3Fonts.bold),
  subtitle01: _extends({
    fontSize: "1rem",
    lineHeight: "1.5rem"
  }, v3Fonts.regular, {
    fontWeight: 500
  }),
  subtitle02: _extends({
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    letterSpacing: "0.0125rem"
  }, v3Fonts.regular, {
    fontWeight: 500
  }),
  subtitle03: _extends({
    fontSize: "0.75rem",
    lineHeight: "1rem",
    letterSpacing: "0.0125rem"
  }, v3Fonts.regular, {
    fontWeight: 500
  }),
  strong: {
    fontWeight: 500
  }
};
var v3Foundations = {
  palette: palette,
  typography: typography,
  spacing: {
    twoExtraSmall: "0.25rem",
    extraSmall: "0.5rem",
    small: "0.75rem",
    medium: "1rem",
    large: "1.5rem",
    extraLarge: "2rem",
    twoExtraLarge: "2.5rem",
    threeExtraLarge: "3rem"
  },
  border: {
    width: {
      thin: "0.0625rem",
      thick: "0.125rem"
    },
    radius: {
      small: "0.125rem",
      medium: "0.1875rem",
      large: "0.1875rem"
    }
  },
  layoutMediaQueries: {
    medium: "@media only screen and (min-width: 31.3125rem)",
    tablet: "@media only screen and (min-width: 48rem)",
    large: "@media only screen and (min-width: 62.5rem)"
  },
  shadow: "0 0.0625rem 0.1875rem 0 rgba(0, 0, 0, 0.2)"
};
var v3FoundationsOverride = function v3FoundationsOverride(foundationsOverride) {
  return function (baseFoundations) {
    var customOverrides = (foundationsOverride == null ? void 0 : foundationsOverride(v3Foundations)) || v3Foundations;
    var palette = _extends({}, baseFoundations.palette, customOverrides.palette);
    var typography = _extends({}, baseFoundations.typography, customOverrides.typography);
    var border = _extends({}, baseFoundations.border, customOverrides.border);
    var layoutMediaQueries = _extends({}, baseFoundations.layoutMediaQueries, customOverrides.layoutMediaQueries);
    var legacy = true;
    return _extends({}, baseFoundations, customOverrides, {
      palette: palette,
      typography: typography,
      border: border,
      layoutMediaQueries: layoutMediaQueries,
      legacy: legacy
    });
  };
};
export default v3FoundationsOverride;